import { make } from './Action'
import Constants from './Constants'
import NotifyActions from './NotifyActions'

/**
 * getSharedNetworks( )
 **/
exports.getSharedNetworks = make( 'getSharedNetworks', Constants.GET_SHARED_NETWORKS, 'networks', 'Failed to get shared networks' )

/**
 * getSharedNetwork( networkId )
 **/
exports.getSharedNetwork = make( 'getSharedNetwork', Constants.GET_NETWORK, 'network', 'Failed to get network' )

/**
 * getNetwork( project )
 **/
exports.getNetworks = make( 'getNetworks', Constants.GET_NETWORKS, 'networks', 'Failed to get shared networks' )

/**
 * addNetwork( project, networkData )
 **/
exports.addNetwork = make( 'addNetwork', Constants.ADD_NETWORK, 'network', 'Failed to add network' )

/**
 * updateNetwork( network, update )
 **/
exports.updateNetwork = make( 'updateNetwork', Constants.UPDATE_NETWORK, 'network', 'Failed to update network' )

/**
 * removeNetwork( networkData )
 **/
exports.removeNetwork = make( 'removeNetwork', Constants.REMOVE_NETWORK, ( m, r, a ) => { m.network = a[0] }, 'Failed to remove network' )

let lastProjectRequest 
exports.requestNetworks = function( project ) {

  return function( dispatch, getState, api ) {
    const n = getState().networks
    if ( n.shared == null || n.shared.length == 0 ) {
      dispatch( exports.getSharedNetworks() )
    }
    if ( project && lastProjectRequest != project ) {
      lastProjectRequest = project
      dispatch( exports.getNetworks( project ) )
    }
  }
}

// function getSharedNetworks( ) {

//   return function( dispatch, getState, api ) {

//     api.getSharedNetworks( )
//       .then( function( result ) {
//         dispatch( { type : Constants.GET_SHARED_NETWORKS, networks : result.items })
//       })
//       .catch( function( ex ) {
//         dispatch( NotifyActions.requestError( 'Failed to get shared networks', ex ) )
//       })  
//     }
// }

// function getNetworks( project ) {

//   return function( dispatch, getState, api ) {
//     api.getNetworks( project )
//       .then( function( result ) {
//         dispatch( { type : Constants.GET_NETWORKS, networks : result.items })
//       })
//       .catch( function( ex ) {
//         dispatch( NotifyActions.requestError( 'Failed to get project networks', ex ) )
//       })  
//     }
//   }

// }

// function getNetwork( nid ) {

//   return function( dispatch, getState, api ) {
//     api.getSharedNetwork( nid )
//       .then( function( result ) {
//         dispatch( { type : Constants.GET_NETWORK, network : result })
//       })
//       .catch( function( ex ) {
//         dispatch( NotifyActions.requestError( 'Failed to get network', ex ) )
//       })  
//     }
//   }
// }

// function addNetwork( project, networkData ) {

//   return function( dispatch, getState, api ) {
//     api.addNetwork( project, data )
//       .then( function( results ) {
//         dispatch( { type : Constants.ADD_NETWORK, network : data })
//       })
//       .catch( function( ex ) {
//         dispatch( NotifyActions.requestError( 'Failed to add network', ex ) )
//       })  
//     }
//   }

// }

// function removeNetwork( networkData ) {

//   return function( dispatch, getState, api ) {
//     api.removeNetwork( networkData )
//       .then( function( result ) {
//         dispatch( { type : Constants.REMOVE_NETWORK, network : networkData })
//       })
//       .catch( function( ex ) {
//         dispatch( NotifyActions.requestError( 'Failed to remove network', ex ) )
//       })  
//     }
//   }

// }

// function updateNetwork( network, update) {

//   return function( dispatch, getState, api ) {
//     api.updateNetwork( network, update )
//       .then( function( result ) {
//         dispatch( { type : Constants.UPDATE_NETWORK, network : result })
//       })
//       .catch( function( ex ) {
//         dispatch( NotifyActions.requestError( 'Failed to update network', ex ) )
//       })  
//     }
//   }

// }

// module.exports = {
//   getSharedNetworks,
//   getNetworks,
//   getNetwork,
//   addNetwork,
//   removeNetwork,
//   updateNetwork
// }
